module.exports = __webpack_public_path__ + "static/media/CPACharg.c237684b.png";